import { REALTIME_ENABLED } from '@/services/realtime/flags'
import { FLAGS } from '@/services/analytics/feature-flags'
import { useFeatureFlag } from '@/services/analytics/use-feature-flag'
import type { ISoundPlayer } from '@/features/scanner/alerts/audio/sound-player'
import { PriceAlertNotifier } from '@/features/price-alerts/price-alert-notifier'
import { AlertWindowNotifier } from '@/features/alert-windows/alert-window-notifier'

/**
 * Price-alert and alert-window toasts over edge-realtime. Each needs the
 * realtime build gate AND its own release flag, so a user whose flag is off
 * never hears or sees a toast.
 */
export function AlertNotifiers({ sound }: { sound: ISoundPlayer }) {
  const priceAlertsOn = useFeatureFlag(FLAGS.PRICE_ALERTS)
  const alertWindowsOn = useFeatureFlag(FLAGS.ALERT_WINDOWS)
  return (
    <>
      {REALTIME_ENABLED && priceAlertsOn && <PriceAlertNotifier sound={sound} />}
      {REALTIME_ENABLED && alertWindowsOn && <AlertWindowNotifier sound={sound} />}
    </>
  )
}
